import axios from "axios";

const BASE_URL = "https://api.vputi.org/";
// const BASE_URL = "http://localhost:8001/";
//const BASE_URL = "http://138.68.94.26:8002/api";

const mapLanguageForApi = (lang: string): string => {
  switch (lang) {
    case "kg":
      return "ky";
    case "tj":
      return "tg";
    default:
      return lang;
  }
};

export const publicRequest = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Helper to get CSRF token from cookies
export const getCsrfToken = (): string => {
  const name = "csrftoken";
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const [key, value] = cookie.trim().split("=");
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return "";
};

// Add CSRF token to POST requests
publicRequest.interceptors.request.use(
  (config) => {
    const currentLanguage =
      (typeof document !== "undefined" && document.documentElement.lang) ||
      "ru";
    config.headers["Accept-Language"] = mapLanguageForApi(currentLanguage);
    if (
      config.method === "post" ||
      config.method === "put" ||
      config.method === "patch" ||
      config.method === "delete"
    ) {
      const csrfToken = getCsrfToken();
      if (csrfToken) {
        config.headers["X-CSRFToken"] = csrfToken;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const userRequest = axios.create({
  baseURL: BASE_URL,
});

userRequest.interceptors.request.use(
  (config) => {
    const currentLanguage =
      (typeof document !== "undefined" && document.documentElement.lang) ||
      "ru";
    config.headers["Accept-Language"] = mapLanguageForApi(currentLanguage);
    return config;
  },
  (error) => Promise.reject(error)
);

export const getApiLanguage = (lang: string): string =>
  mapLanguageForApi(lang || "ru");

// const setupInterceptors = (store: AppStore) => {
//   userRequest.interceptors.request.use(
//     (config) => {
//       const state = store.getState();
//       const accessToken = state.auth.access;

//       if (accessToken) {
//         config.headers["Authorization"] = `Bearer ${accessToken}`;
//       }
//       return config;
//     },
//     (error) => Promise.reject(error)
//   );

//   userRequest.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//       const originalRequest = error.config;

//       const isTokenError =
//         error.response?.status === 401 &&
//         error.response?.data?.code === "token_not_valid" &&
//         error.response?.data?.messages?.[0]?.token_class === "AccessToken";

//       if (isTokenError && !originalRequest._retry) {
//         originalRequest._retry = true;

//         if (isRefreshing) {
//           return new Promise(function (resolve, reject) {
//             failedQueue.push({
//               resolve: (token: string) => {
//                 originalRequest.headers["Authorization"] = `Bearer ${token}`;

//                 if (originalRequest._formDataBackup) {
//                   originalRequest.data = originalRequest._formDataBackup;
//                 }

//                 resolve(userRequest(originalRequest));
//               },
//               reject: (err: any) => reject(err),
//             });
//           });
//         }

//         isRefreshing = true;

//         try {
//           const result = await store.dispatch(refreshToken());

//           if (refreshToken.fulfilled.match(result)) {
//             const newAccessToken = result.payload.access;

//             processQueue(null, newAccessToken);
//             originalRequest.headers["Authorization"] =
//               `Bearer ${newAccessToken}`;

//             if (originalRequest._formDataBackup) {
//               originalRequest.data = originalRequest._formDataBackup;
//             }

//             return userRequest(originalRequest);
//           } else {
//             processQueue(new Error("Refresh failed"), null);
//             await store.dispatch(logout());
//             window.location.href = "/login";
//             return Promise.reject(error);
//           }
//         } catch (err) {
//           processQueue(err, null);
//           await store.dispatch(logout());
//           window.location.href = "/login";
//           return Promise.reject(err);
//         } finally {
//           isRefreshing = false;
//         }
//       }

//       return Promise.reject(error);
//     }
//   );
// };
//export { setupInterceptors };
